let config = {
  inputLabel: 'backgroundImageUrl',
  key: 'backgroundimgurl',
  inputType: 'textfield',
};

export default config;
